import { createContext } from "react";

/**
 * The active page's title, published by each route (PageTitle in App.tsx) so the
 * persistent header can show it in the breadcrumb when the page has no nav entry.
 */
export interface PageTitleContextValue {
    pageTitle: string;
    setPageTitle: (title: string) => void;
}

export const PageTitleContext = createContext<PageTitleContextValue>({
    pageTitle: "",
    setPageTitle: () => {},
});
